import { render, staticRenderFns } from "./WallboardTable.vue?vue&type=template&id=12c34e3b"
import script from "./WallboardTable.vue?vue&type=script&lang=ts"
export * from "./WallboardTable.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports